module.exports = __webpack_public_path__ + "img/thumbnails-3-custom-video-player.e57fc809.png";